module.exports = __webpack_public_path__ + "assets/img/9_1008_big.4eae290b.jpg";